import { render, staticRenderFns } from "./WindowSidebar.vue?vue&type=template&id=8a3cc3e4&"
import script from "./WindowSidebar.vue?vue&type=script&lang=js&"
export * from "./WindowSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports